<ng-container *ngIf="personPayrollLogs$ | async as personPayrollLogs">
  <gp-table class="table">
    <thead gp-table-head>
    <tr role="row">
      <th class="column-title text-muted small" gp-table-column id="created">
        {{ 'SDC.created' | translate }}
      </th>
      <th class="column-title text-muted small" gp-table-column id="Updated">
        {{ 'SDC.updated' | translate }}
      </th>
      <th class="column-title text-muted small" gp-table-column id="entity">
        {{ 'SDC.entity' | translate }}
      </th>
      <th class="column-title text-muted small" gp-table-column id="Parent key">
        {{ 'SDC.parent.key' | translate }}
      </th>
      <th class="column-title text-muted small" gp-table-column id="Key">
        {{ 'SDC.key' | translate }}
      </th>
      <th class="column-title text-muted small" gp-table-column id="Values">
        {{ 'SDC.Person.Log.values' | translate }}
      </th>
      <th class="column-title text-muted small" gp-table-column id="Status">
        {{ 'COMMON.status' | translate }}
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngIf="loading">
      <td class="text-center p-t-lg p-b-lg" colspan="11">
        <em class="fa fa-light fa-spinner fa-spin"></em>
      </td>
    </tr>
    <tr *ngFor="let personLog of personPayrollLogs">
      <td headers="created">
        {{
          personLog.creationDate | gpDate:{
            withTime: true,
            timezone: timezone
          }
        }}
      </td>
      <td headers="updated">
        {{
          personLog.updateDate | gpDate:{
            withTime: true,
            timezone: timezone
          }
        }}
      </td>
      <td [ngClass]="{'emphasized': emphasized(personLog)}" headers="entity">
        {{ personLog.entity }}
      </td>
      <td [ngClass]="{'emphasized': emphasized(personLog)}" headers="parentKey">
        {{ personLog.parentKey }}
      </td>
      <td [ngClass]="{'emphasized': emphasized(personLog)}" headers="key">
        {{ personLog.key }}
      </td>
      <td headers="Values">
        <copy-to-clipboard
          [data]="getPrettyJson(personLog.values)">
        </copy-to-clipboard>
      </td>
      <td headers="status">
        <span class="person-log-status" [ngClass]="'person-log-status-' + personLog.status">{{ personLog.status }}</span>
      </td>
    </tr>
    <tr *ngIf="!loading && personPayrollLogs?.length === 0">
      <td class="text-center p-t-lg p-b-lg" colspan="11">
        {{ noLogsMessageKey | translate }}
      </td>
    </tr>
    </tbody>
  </gp-table>
  <gp-table-pagination
    [pagination]="pagination">
  </gp-table-pagination>
</ng-container>
